import { CommunicationLogsSearchParams } from './CommunicationLogsSearchMapper.types'
import { handleLogTypeParam } from '@/modules/Telemedicine/pages/CommunicationLogs/CommunicationLogs.constants'

class CommunicationLogsSearchMapper {
  toPersistence(domainData: CommunicationLogsSearchParams) {
    return {
      dataInicio: domainData?.initialDate,
      dataFim: domainData?.endDate,
      itemsPerPage: domainData?.itemsPerPage,
      page: domainData?.page,
      termo: domainData?.searchTerm,
      tipoLog: handleLogTypeParam(domainData?.logType),
    }
  }
}

export default new CommunicationLogsSearchMapper()
